import React from 'react'
import { changePassword } from '../../../../redux/user/helpers'

import './style.css'

class ChangePassword extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      fields: props.args.fields
    }
  }

  render() {
    if (this.state.changeSuccess)
      return (
        <div className="change-password centered padded">
          <h2>{this.state.fields.passwordUpdateSuccessMessage}</h2>
        </div>
      )

    return (
      <div className="change-password centered padded">
        <h2>{this.state.fields.passwordPopupHeader}</h2>
        <form
          name="updatePasswordForm"
          className="update-password-form"
          onSubmit={ e => this.handleSubmit(e) } noValidate>
          <label id="currentPasswordLabel">{this.state.fields.passwordPopupCurrentPassword}</label>
          <input 
            type="password" 
            name="currentPassword"
            placeholder={this.state.fields.passwordPopupCurrentPassword}
            ref={ e => this.currentPasswordInput = e }
            autoComplete="false"
            required />

          <label id="newPasswordLabel">{this.state.fields.passwordPopupNewPassword}</label>
          <input
            type="password" 
            name="newPassword"
            ref={ e => this.newPasswordInput = e }
            placeholder={this.state.fields.passwordPopupNewPassword}
            autoComplete="false"
            required />

          <label id="confirmPasswordLabel">{this.state.fields.passwordPopupConfirmPassword}</label>
          <input
            type="password"
            ref={ e => this.confirmPasswordInput = e }
            name="confirmPassword"
            placeholder={this.state.fields.passwordPopupConfirmPassword}
            autoComplete="false"
            required />
          { this.state.error && (<div className="error">{ this.state.error }</div>) }
          <div className="text-center">
            <input
              type="submit"
              className={'button cta' + (this.state.processing ? ' processing': '') }
              value={this.state.fields.passwordPopupUpdate}/>
          </div>
        </form>
      </div>
    )
  }

  handleSubmit(e) {
    e.preventDefault()
    if (!this.validate())
      return

    this.setState({...this.state, processing: true })

    changePassword({
      newPassword: this.newPasswordInput.value,
      oldPassword: this.currentPasswordInput.value,
    }).then((response) => {
      this.setState({...this.state, changeSuccess: true })
    }).catch(e =>{
      var x = ''
      x= this.state.fields[e.response.data.code] || this.state.fields.passwordUpdateErrorMessage
      this.displayError(x)
    }).then(_ => {
      this.setState({...this.state, processing: false })
    })
  }

  displayError(e) {
    this.setState({...this.state, error: e })
    setTimeout(_ => this.setState({...this.state, error: null }), 5000)
  }

  validate() {
    if (!this.newPasswordInput.value || this.newPasswordInput.value.length <= 4 ) {
      this.displayError(this.state.fields.passwordLengthError)
      return false
    }

    if (this.confirmPasswordInput.value !== this.newPasswordInput.value) {
      this.displayError(this.state.fields.passwordMismatchError)
      return false
    }

    return true
  }
}

export default ChangePassword;